import { Flex, List, Progress } from '@mantine/core'

import type { MultipleBarChartProps } from '@/components/MultipleBarChart/MultipleBarChart.types'
import { Text } from '@/components/Text/Text'

import classes from './MultipleBarChart.module.css'

export function MultipleBarChart({
  sections,
  showLabels = true,
}: MultipleBarChartProps) {
  return (
    <Flex
      direction="column"
      h={showLabels ? 75 : 'auto'}
      justify="space-between"
    >
      <Progress.Root radius="xl" size="lg">
        {sections.map(section => (
          <Progress.Section
            key={section.label}
            color={section.color}
            value={section.value}
          />
        ))}
      </Progress.Root>

      {showLabels && (
        <List className={classes.legend}>
          {sections.map(section => (
            <List.Item key={section.label}>
              <Flex align="center" gap={8}>
                <span
                  className={classes.dot}
                  style={{
                    backgroundColor: section.color,
                  }}
                />

                <Text variant="body_2_black">
                  {section.label} - {section.initialValue}
                </Text>
              </Flex>
            </List.Item>
          ))}
        </List>
      )}
    </Flex>
  )
}
